import { useState, useCallback } from 'react';

const DEFAULT_LAYER_STYLE = {
  fontSize: 40,
  fontFamily: 'Oswald',
  color: '#ffffff',
  strokeColor: '#000000',
  strokeWidth: 2,
  shadowBlur: 4,
  shadowColor: '#000000',
  align: 'center',
  bold: true,
  italic: false,
  uppercase: true
};

const INITIAL_LAYERS = [
  { id: '1', text: 'TOP TEXT', x: 50, y: 10, ...DEFAULT_LAYER_STYLE },
  { id: '2', text: 'BOTTOM TEXT', x: 50, y: 85, ...DEFAULT_LAYER_STYLE }
];

export const useTextLayers = () => {
  const [textLayers, setTextLayers] = useState(INITIAL_LAYERS);
  const [selectedLayerId, setSelectedLayerId] = useState('1');

  const selectedLayer = textLayers.find(l => l.id === selectedLayerId);

  const updateLayer = useCallback((id, updates) => {
    setTextLayers(prev => prev.map(layer =>
      layer.id === id ? { ...layer, ...updates } : layer
    ));
  }, []);

  const addTextLayer = useCallback(() => {
    const newId = String(Date.now());
    setTextLayers(prev => [...prev, {
      id: newId, text: 'NEW TEXT', x: 50, y: 50,
      ...DEFAULT_LAYER_STYLE, fontSize: 32
    }]);
    setSelectedLayerId(newId);
  }, []);

  const deleteLayer = useCallback((id) => {
    setTextLayers(prev => {
      const filtered = prev.filter(layer => layer.id !== id);
      if (id === selectedLayerId) {
        setSelectedLayerId(filtered[0]?.id || null);
      }
      return filtered;
    });
  }, [selectedLayerId]);

  const prefillFirstLayer = useCallback((text) => {
    setTextLayers(prev => prev.map((layer, idx) =>
      idx === 0 ? { ...layer, text, uppercase: false } : layer
    ));
  }, []);

  return {
    textLayers, setTextLayers,
    selectedLayerId, setSelectedLayerId,
    selectedLayer,
    updateLayer, addTextLayer, deleteLayer, prefillFirstLayer
  };
};
